module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_big_cn.f5b233b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_big_cn.jpg
// module id = 2976
// module chunks = 11